import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_2 = { class: "flex items-center space-x-4" }
const _hoisted_3 = { class: "gap-4 md:grid md:grid-cols-8" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-6 md:flex-row"
}
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = {
  for: "media",
  class: "mb-2 block text-sm font-medium leading-7 text-gray-900"
}
const _hoisted_7 = { class: "flex-grow" }
const _hoisted_8 = { class: "flex-grow" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-end"
}
const _hoisted_10 = { class: "sr-only" }
const _hoisted_11 = { class: "flex justify-end px-4 sm:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiCheckboxInput = _resolveComponent("UiCheckboxInput")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-4 p-4 sm:p-6 lg:p-8",
    autocomplete: "off",
    onSubmit: _withModifiers($setup.onSubmit, ["prevent"])
  }, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('script.' + $setup.props.action + '.title')), 1 /* TEXT */)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListScript' } }),
          (
                            ($setup.props.action == $setup.FormAction.CREATE && _ctx.$can($setup.Permission.CREATE_SCRIPT)) ||
                            ($setup.props.action == $setup.FormAction.EDIT && _ctx.$can($setup.Permission.EDIT_SCRIPT))
                        )
            ? (_openBlock(), _createBlock(_component_UiButton, {
                key: 0,
                type: "submit",
                variant: "primary",
                "text-variant": "white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Save')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_UiPanel, { class: "space-y-4" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiTextInput, {
            modelValue: $setup.v$.clientUrl.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.clientUrl.$model) = $event)),
            name: "clientUrl",
            type: "text",
            label: _ctx.$t('script.labels.clientUrl'),
            errors: $setup.v$.clientUrl.$errors,
            required: $setup.v$.clientUrl.required !== undefined,
            disabled: $setup.props.action == $setup.FormAction.EDIT,
            class: "md:col-span-6 lg:col-span-4",
            onBlur: $setup.v$.clientUrl.$touch
          }, null, 8 /* PROPS */, ["modelValue", "label", "errors", "required", "disabled", "onBlur"]),
          _createVNode(_component_UiCheckboxInput, {
            modelValue: $setup.formState.includeJquery,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formState.includeJquery) = $event)),
            name: "includeJquery",
            label: _ctx.$t('script.labels.includeJquery'),
            class: "col-span-2"
          }, null, 8 /* PROPS */, ["modelValue", "label"]),
          _createVNode(_component_UiCheckboxInput, {
            modelValue: $setup.formState.isActive,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formState.isActive) = $event)),
            name: "isActive",
            label: _ctx.$t('script.labels.isActive'),
            class: "col-span-2"
          }, null, 8 /* PROPS */, ["modelValue", "label"])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formState.numbers, (number, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_UiPanel, null, {
          default: _withCtx(() => [
            ($setup.vv$[index])
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString($setup.t('script.labels.media')), 1 /* TEXT */),
                    _createVNode(_component_UiMultiselect, {
                      modelValue: number.media,
                      "onUpdate:modelValue": ($event: any) => ((number.media) = $event),
                      name: "media",
                      label: "label",
                      "value-prop": "value",
                      options: $setup.mediaOptions,
                      errors: $setup.vv$[index].value.media.$errors,
                      onBlur: $setup.vv$[index].value.media.$touch
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "errors", "onBlur"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_UiTextInput, {
                      modelValue: number.fromNumber,
                      "onUpdate:modelValue": ($event: any) => ((number.fromNumber) = $event),
                      name: "fromNumber",
                      type: "text",
                      label: $setup.t('script.labels.fromNumber'),
                      errors: $setup.vv$[index].value.fromNumber.$errors,
                      onBlur: $setup.vv$[index].value.fromNumber.$touch
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "errors", "onBlur"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_UiTextInput, {
                      modelValue: number.toNumber,
                      "onUpdate:modelValue": ($event: any) => ((number.toNumber) = $event),
                      name: "toNumber",
                      type: "text",
                      label: $setup.t('script.labels.toNumber'),
                      errors: $setup.vv$[index].value.toNumber.$errors,
                      onBlur: $setup.vv$[index].value.toNumber.$touch
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "label", "errors", "onBlur"])
                  ]),
                  ($setup.formState.numbers.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _withDirectives((_openBlock(), _createBlock(_component_UiButton, {
                          size: "",
                          shape: "rounded-full",
                          variant: "inherit",
                          "text-variant": "danger",
                          shadow: "none",
                          themed: "",
                          class: "focus:ring-danger ml-1 border-transparent text-sm shadow-none",
                          onClick: ($event: any) => ($setup.removeNumber(index))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.t('core.actions.Remove')), 1 /* TEXT */),
                            _createVNode($setup["TrashIcon"], {
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                          [_directive_tippy, $setup.t('core.actions.Remove')]
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_UiButton, {
        variant: "white",
        "text-variant": "gray-500",
        class: "ml-4",
        onClick: $setup.addNumber
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('script.actions.addNumber')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 32 /* NEED_HYDRATION */))
}